/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import StatusBadge from './StatusBadge';
import { INTERVIEW_RESULT_LABEL } from '../constants';

// Resultado da entrevista. `null` = entrevista ativa (sem resultado) → "Aguardando".
const RESULT_VARIANT = {
   PROXIMA_ETAPA: 'green',
   APROVADO: 'green',
   INCOMPATIVEL: 'red',
   REPROVADO: 'red',
   RECUSA_DE_VAGA: 'amber',
   DESISTIU: 'amber',
   NAO_COMPARECEU: 'amber',
   REMARCADO: 'neutral',
};

export default function InterviewResultBadge({ value }) {
   if (!value) {
      return <StatusBadge variant="blue">Aguardando resultado</StatusBadge>;
   }
   return (
      <StatusBadge variant={RESULT_VARIANT[value] ?? 'neutral'}>
         {INTERVIEW_RESULT_LABEL[value] ?? value}
      </StatusBadge>
   );
}

InterviewResultBadge.propTypes = {
   value: PropTypes.string,
};
